// REACT
import React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// VENDOR COMPONENTS
import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Badge from 'material-ui/Badge';

class ServiceListItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gotCount: false,
        };
    }

    componentDidMount() {
        this.props.services.map(service => {
            this.getUnreadCount(service);
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.unreadContentCount !== nextProps.unreadContentCount) {
            this.props.services.map(service => {
                this.getUnreadCount(service);
            });
        }
    }

    getUnreadCount = service => {
        // console.log('GETTING UNREAD COUNT FOR SERVICE:', service._id);
        if (!this.state.gotCount && this.props.selectedClient) {
            // GET UNREADS FOR SERVICE PROVIDER // console.log('GETTING UNREAD NOTIFICATIONS FOR SERVICE PROVIDER');
            this.props.checkUnreadsForServiceConsumerPair(
                this.props.userId,
                this.props.selectedClient.uid,
                service._id,
            ); // Checks provider user's service for unread notifications
            this.setState({
                gotCount: true,
            });
        }
        if (!this.state.gotCount && !this.props.selectedClient) {
            // GET UNREADS FOR HEALTH CONSUMER // console.log('GETTING UNREAD NOTIFICATIONS FOR HEALTH CONSUMER');
            this.props.checkUnreadsForService(
                this.props.userId,
                null,
                service._id,
            ); // Checks provider user's service for unread notifications
            this.setState({
                gotCount: true,
            });
        }
    };

    render() {
        const {
            providers,
            services,
            onServiceSelect,
            header = null,
            divider = null,
            showServicePhoto = null,
            checkUnreadsForUserService,
            style = null,
        } = this.props;

        return (
            <div id="ServiceListItems-OuterContainer" style={style}>
                {header && <Subheader>{header}</Subheader>}
                {services.map((service, i) => {
                    // GET THE PROVIDER FOR THIS SERVICE
                    let provider = providers.filter(serviceProvider => {
                        if (serviceProvider.uid === service.provider) {
                            return true;
                        }
                    })[0]; // Get provider from array, hence [0]

                    return (
                        <ListItem
                            key={service._id}
                            leftAvatar={
                                <Avatar
                                    src={
                                        showServicePhoto
                                            ? service.coverPhotoURL
                                            : provider.profilePhotoURL
                                    }
                                />
                            }
                            rightIcon={
                                <Badge
                                    badgeContent={
                                        this.props.unreadContentCount &&
                                        this.props.unreadContentCount[
                                            service._id
                                        ] &&
                                        this.props.unreadContentCount[
                                            service._id
                                        ].count
                                    }
                                    secondary={true}
                                    style={{
                                        display:
                                            this.props.unreadContentCount &&
                                            this.props.unreadContentCount[
                                                service._id
                                            ] &&
                                            this.props.unreadContentCount[
                                                service._id
                                            ].count
                                                ? 'block'
                                                : 'none',
                                    }}
                                />
                            }
                            primaryText={service.name}
                            secondaryText={`with ${provider.name &&
                                provider.name.first} ${provider.name &&
                                provider.name.last}`}
                            style={{
                                width: '100%',
                                textOverflow: 'ellipsis',
                                backgroundColor:
                                    this.props.unreadContentCount &&
                                    this.props.unreadContentCount[
                                        service._id
                                    ] &&
                                    this.props.unreadContentCount[service._id]
                                        .count > 0
                                        ? 'rgba(200,200,200, 0.3)'
                                        : 'white',
                            }}
                            onClick={() => onServiceSelect(service)}
                            nestedListStyle={{
                                marginRight: 30,
                                marginLeft: 30,
                            }}
                        />
                    );
                })}
                {divider && <Divider />}
            </div>
        );
    }
}

const mapStateToProps = ({ notification, auth }) => {
    // console.log('NOTIFICATION UNREAD COUNTS @ SERVICE LIST ITEMS', notification.unreadCount);
    // console.log(
    //     'UNREAD CONTENT COUNT FOR SERVICE LIST:',
    //     notification.unreadCount && notification.unreadCount,
    // );

    return {
        unreadContentCount:
            notification.unreadCount && notification.unreadCount,
        userId: auth.authData.id,
    };
};

export default connect(
    mapStateToProps,
    actions,
)(ServiceListItems);



// WEBPACK FOOTER //
// ./src/js/components/ServiceListItems.jsx